import './style.css';
import React from 'react';
import { Tooltip } from '../../../../component';
var CustomButton = function (_a) {
    var render = _a.render, name = _a.name, configTooltip = _a.tooltip, editor = _a.editor;
    var renderContent = function () { return render(editor); };
    var localeTip = editor.configurator.getLocaleValue(name).tooltip;
    var tooltip = configTooltip || localeTip;
    return (React.createElement("div", { className: 'syl-toolbar-tool custom ' + (name || '') }, tooltip ? React.createElement(Tooltip, { content: tooltip }, renderContent()) : renderContent()));
};
export { CustomButton };
//# sourceMappingURL=index.js.map